module.exports = __webpack_public_path__ + "img/logo.2c73aae6.png";